module.exports = __webpack_public_path__ + "img/trash.5d29fef4.svg";